import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import ProfissionalList from "./ProfissionalList";
import Template from "../../layout/Template";
import { ProfissionaisService } from "../../services/api/Profissionais/ProfissionaisService"
import { useEffect, useState } from "react";
import ModalSimNao from "../../components/ModalSimNao";
import PaginacaoLinks from "../../components/Paginacao/PaginacaoLinks";
import Loading from "../../components/Loader/Loading";
import PermissoesComponent from "../../components/PermissaoComponent";
import { usePermissoes } from "../../hooks/usePermissoes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

const Profissionais = () => {

    const [paginacao, setPaginacao] = useState({
        currentPage: null,
        totalPages: null,
        nextPage: null,
        prevPage: null

    })

    const [showModalSN, setShowModalSN] = useState(false)
    const [idDelete, setIdDelete] = useState(null)
    const [search, setSearch] = useState('')
    const [timeDelay, setTimeDelay] = useState(null)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 4, acoesId: 1 },
        { secoesId: 4, acoesId: 2 },
        { secoesId: 4, acoesId: 3 },
        { secoesId: 4, acoesId: 4 }
    ])

    const fecthProfissionais = async (page) => {
        setIsloading(true);
        let filtros = { page: page };
        const res = await ProfissionaisService.getAll(search, filtros)
        // console.log(res)
        if (res != undefined) {
            const data = res.data;
            setProfissionais(data)
            setPaginacao({
                currentPage: res.meta.current_page,
                totalPages: Math.ceil(res.meta.total / res.meta.per_page),
                nextPage: (res.meta.current_page + 1),
                prevPage: (res.meta.current_page - 1)
            })
        }
        setIsloading(false);
    }
    const [profissionais, setProfissionais] = useState([])

    useEffect(() => {
        fecthProfissionais()
    }, [])



    const handleCloseModalSn = () => {
        setShowModalSN(false)
        setIdDelete(null)
    }

    const handleDelete = (idCliente) => {
        setIdDelete(idCliente)
        setShowModalSN(true)
    }

    const handleConfirmDelete = async () => {
        const data = await ProfissionaisService.deleteById(idDelete)
        fecthProfissionais()
        // console.log(data)
        setIdDelete(null)
        setShowModalSN(false)
    }


    const handleChangeBusca = (e) => {

        clearTimeout(timeDelay)

        setSearch(e.target.value)

        let time = setTimeout(function () {

            if (e.target.value.length >= 3) {
                fecthProfissionais()

            } else {
                fecthProfissionais()
            }

        }, 300)
        setTimeDelay(time);




    }
    const onClickPage = async (page) => {
        await fecthProfissionais(page)
    }
    return (

        <>

            <Template>
                <div className="box-fundo">



                    <Row style={{ flexDirection: 'row' }}>
                        <Col xs={12} md={6} >
                            <h3 className="">Profissionais
                                <Button variant="success" size="sm" style={{ marginLeft: '15px' }} href="/admin/profissionais/cadEdit"><FontAwesomeIcon icon={faPlusCircle} /> Adicionar</Button>
                            </h3>
                        </Col>

                        <Col xs={12} md={6}>
                            <Form.Control type="text" placeholder="Buscar  profissional" size="sm" onChange={(e) => handleChangeBusca(e)} />
                        </Col>
                    </Row>
                    <hr></hr>
                    {(isLoading) ? <Loading /> : (
                        <>
                            {(!listPermissoes?.ver && !isLoadingPerm) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                                <>

                                    {(profissionais.length > 0) ? (
                                        <>
                                            <Table striped bordered hover size="sm" style={{ marginTop: '15px' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Cod.</th>
                                                        <th>Nome</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ProfissionalList listPermissoes={listPermissoes} setIsloading={setIsloading} listProfissional={profissionais} fecthProfissionais={fecthProfissionais} handleDelete={handleDelete} />
                                                </tbody>
                                            </Table>

                                            <PaginacaoLinks totalPages={paginacao?.totalPages}
                                                currentPage={paginacao?.current_page}
                                                onClickPage={onClickPage}
                                            ></PaginacaoLinks>
                                        </>) : <div className="alert alert-warning text-center">Sem profissionais registrados</div>}

                                </>
                            )}
                        
                </>
                )}
                </div>
                <ModalSimNao show={showModalSN} handleClose={() => setShowModalSN(false)} handleConfirm={() => handleConfirmDelete()}>Tem certeza que deseja excluir este cliente?</ModalSimNao>
            </Template>

        </>


    )
}

export default Profissionais;